import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            ariaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Project_ContextMenuButton.ariaLabel?c=32e3u9wl2fvg", defaultMessage: "Open project context menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
